module.exports = __webpack_public_path__ + "img/section5-2.b57fd265.svg";